import { getDate, dateDiffInDays } from "@/helper/date";
import UploadController from "@/controller/uploadController";

class Database {
    addInspectionToDatabase(event, inspectionData) {
        const db = event.target.result;
        const inspectionObjectStore = db
            .transaction(["inspections"], "readwrite")
            .objectStore("inspections");

        const request = inspectionObjectStore.add(inspectionData);

        request.onsuccess = (event) => {
            console.log("Vistoria salva com sucesso\nId: ", event.target.result);
        };
    }

    updateInspectionsOnDatabase(event, inspections) {
        if (inspections.length > 0) {
            const db = event.target.result;
            const inspectionObjectStore = db
                .transaction(["inspections"], "readwrite")
                .objectStore("inspections");
            let i = 0;
            inspectionObjectStore.openCursor().onsuccess = (event) => {
                const cursor = event.target.result;
                if (cursor) {
                    if (cursor.value && cursor.value.id === inspections[i].id) {
                        const update = cursor.update(inspections[i]);
                        i++;
                        update.onsuccess = () => {
                            console.log("Vistoria alterada com sucesso!");
                        };
                    }
                    cursor.continue();
                }
            };
        }
    }

    updateInspectionOnDatabase(event, inspection) {
        const db = event.target.result;
        const inspectionObjectStore = db
            .transaction(["inspections"], "readwrite")
            .objectStore("inspections");
        inspectionObjectStore.openCursor().onsuccess = (event) => {
            const cursor = event.target.result;
            if (cursor) {
                if (cursor.value && cursor.value.id === inspection.id) {
                    const update = cursor.update(inspection);
                    update.onsuccess = () => {
                        console.log("Vistoria alterada com sucesso!");
                    };
                }
                cursor.continue();
            }
        };
    }

    getFullInspectionData(event, inspection) {
        return new Promise((resolve, reject) => {
            const db = event.target.result;
            const inspectionObjectStore = db
                .transaction(["inspections"], "readwrite")
                .objectStore("inspections");
            inspectionObjectStore.openCursor().onsuccess = (event) => {
                const cursor = event.target.result;
                if (cursor) {
                    if (cursor.value && cursor.value.id === inspection.id) {
                        resolve(cursor.value);
                    }
                    cursor.continue();
                }
            };
            inspectionObjectStore.openCursor().onerror = (err) => {
                reject(err);
            };
        });
    }

    c(event, inspection) {
        const vm = this;
        return new Promise(function (resolve, reject) {
            const db = event.target.result;
            vm.getFullInspectionData(event, inspection)
                .then((fullInspection) => {
                    const inspectionObjectStore = db
                        .transaction(["inspections"], "readwrite")
                        .objectStore("inspections");
                    inspectionObjectStore.openCursor().onsuccess = (event) => {
                        const cursor = event.target.result;
                        if (cursor) {
                            if (cursor.value && cursor.value.id === fullInspection.id) {
                                fullInspection.status = "Pendente";
                                const update = cursor.update(fullInspection);
                                update.onsuccess = () => {
                                    console.log("Vistoria alterada com sucesso!");
                                    resolve("");
                                };
                                update.onerror = (err) => {
                                    console.error(err);
                                    reject(err);
                                };
                            }
                            cursor.continue();
                        }
                    };
                    inspectionObjectStore.openCursor().onerror = (err) => {
                        console.error(err);
                        reject(err);
                    };
                })
                .catch((err) => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    getAllPendingInspections(event) {
        return new Promise((resolve, reject) => {
            const db = event.target.result;
            const objectStore = db
                .transaction(["inspections"], "readwrite")
                .objectStore("inspections");
            const getAllObjects = objectStore.getAll();
            getAllObjects.onsuccess = () => {
                //pendingInspections will contain all inspections stored in indexeddb that has status = Pendente.
                const pendingInspections = getAllObjects.result.filter(
                    (inspection) => inspection.status === "Pendente"
                );
                resolve(pendingInspections);
            };
            getAllObjects.onerror = () => {
                reject(getAllObjects.error);
            };
        });
    }

    deleteInspectionIfStoredMoreThan7Days(event) {
        const db = event.target.result;
        const inspectionObjectStore = db
            .transaction(["inspections"], "readwrite")
            .objectStore("inspections");
        const date = getDate();
        inspectionObjectStore.openCursor().onsuccess = (event) => {
            const cursor = event.target.result;
            if (cursor) {
                const diffDays = dateDiffInDays(cursor.value.date, date);
                if (diffDays > 7 && cursor.value.status === "Enviado") {
                    const del = cursor.delete();
                    del.onsuccess = () => {
                        console.log(
                            "Vistoria apagada com sucesso! Vistoria realizada há mais de 7 dias!"
                        );
                    };
                }
                cursor.continue();
            }
        };
    }

    createOrOpenDatabase(infos, id = null) {
        return new Promise((resolve, reject) => {
            const request = window.indexedDB.open("Inovaclickteste", 1);
            const upload = new UploadController();

            request.onerror = (err) => {
                console.log("error criacao/abertura do banco indexed");
                reject(err);
            };

            request.onsuccess = (event) => {
                this.deleteInspectionIfStoredMoreThan7Days(event);
                if (infos.inspectionData) {
                    this.addInspectionToDatabase(event, infos.inspectionData);
                } else if (infos.transmitInspection) {
                    upload
                        .sendAllPendingInspectionsToServer(event)
                        .then((response) => {
                            console.log("RES", response);
                            resolve(response);
                        })
                        .catch((err) => {
                            console.error("err", err);
                            reject(err);
                        });
                } else if (infos.listInspection) {
                    this.getListInspections(event)
                        .then((response) => resolve(response))
                        .catch((err) => reject(err));
                } else if (infos.listAllInspectionData) {
                    this.getAllInspectionsData(event)
                        .then((response) => resolve(response))
                        .catch((err) => reject(err));
                } else if (infos.pegarImagens) {
                    this.getImagensInspection(event, id)
                        .then((response) => resolve(response))
                        .catch((err) => reject(err));
                }
            };

            request.onupgradeneeded = (event) => {
                const db = event.target.result;
                const objectStore = db.createObjectStore("inspections", {
                    keyPath: "id",
                    autoIncrement: true,
                });
                objectStore.createIndex("id", "id", { unique: true });
                objectStore.createIndex("numberPlate", "numberPlate", {
                    unique: false,
                });
                objectStore.createIndex("status", "status", { unique: false });
            };
        });
    }

    getListInspections(event) {
        return new Promise((resolve, reject) => {
            const db = event.target.result;
            const inspections = [];

            const objectStore = db
                .transaction(["inspections"], "readwrite")
                .objectStore("inspections");
            const getAllObjects = objectStore.getAll();
            getAllObjects.onsuccess = () => {
                getAllObjects.result.forEach((inspection) => {
                    inspections.push({
                        id: inspection.id,
                        idVistoria: inspection.id_vistoria,
                        placa: inspection.inspectionData.numberPlate,
                        questionario: inspection.inspectionData.quizType,
                        tipoDeOperacao: inspection.inspectionData.operation.nome,
                        data: inspection.date,
                        hora: inspection.hour,
                        status: inspection.status,
                        token: inspection.enterprise.enterprise,
                    });
                });
                
                resolve(inspections);
            };
            getAllObjects.onerror = () => {
                reject(getAllObjects.error);
            };
        });
    }

    getImagensInspection(event, id) {
        return new Promise((resolve, reject) => {
            const db = event.target.result;
            const imagens = [];

            const objectStore = db
                .transaction(["inspections"], "readwrite")
                .objectStore("inspections");
            const getAllObjects = objectStore.getAll();
            getAllObjects.onsuccess = () => {
                getAllObjects.result.forEach((inspection) => {
                    if (inspection.id === id) {
                        const photos = inspection.inspectionData.photos;
                        if (photos && photos.length > 0) {
                            photos.forEach((photo) => {
                                imagens.push(photo);
                            });
                        }
                    }
                });
                resolve(imagens);
            };
            getAllObjects.onerror = () => {
                reject(getAllObjects.error);
            };
        });
    }

    getAllInspectionsData(event) {
        return new Promise((resolve, reject) => {
            const db = event.target.result;
            const inspections = [];

            const objectStore = db
                .transaction(["inspections"], "readwrite")
                .objectStore("inspections");
            const getAllObjects = objectStore.getAll();
            getAllObjects.onsuccess = () => {
                getAllObjects.result.forEach((inspection) => {
                    inspections.push({
                        inspection,
                    });
                });
                resolve(inspections);
            };
            getAllObjects.onerror = () => {
                reject(getAllObjects.error);
            };
        });
    }
}

export default Database;
